"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3640],{

/***/ 90756:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SecurityLogos; }
});

// UNUSED EXPORTS: LOGO_SIZES

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/core-components/security-logos/security-logos.scss.js


var StyledSecurityLogos = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1q2zonn0"
})("display:flex;flex-wrap:wrap;justify-content:center;.security-logo-wrapper{&:not(:last-child){margin-right:24px;@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){margin-right:20px;}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH_M */.TI, "){margin-right:16px;}}.security-logo{height:72px;&.small-logo{height:48px;}}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/security-logos/default-props.js
/* harmony default export */ var default_props = ({
    logosNumber: 5,
    smallLogos: false
});

// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./segments/desktop/core-components/security-logos/security-logos.js






function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}






var LOGO_SIZES = {
    LARGE: "large",
    MEDIUM: "medium"
};
var LOGOS = [
    "/static/img/security/gdpr_v2.png",
    "/static/img/security/iso_27001_v2.png",
    "/static/img/security/iso_27018_v2.png",
    "/static/img/security/soc_v2.png",
    "/static/img/security/hipaa_v2.png"
];
var SecurityLogos = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(SecurityLogos, PureComponent);
    var _super = (0,_create_super/* default */.Z)(SecurityLogos);
    function SecurityLogos() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_class_call_check/* default */.Z)(this, SecurityLogos);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0,_to_consumable_array/* default */.Z)(args)));
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "renderLogo", function(logo, index) {
            var smallLogos = _this.props.smallLogos;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "security-logo-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                    src: logo,
                    className: classnames_default()("security-logo", {
                        "small-logo": smallLogos
                    })
                })
            }, index);
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(SecurityLogos, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var logosNumber = this.props.logosNumber;
                var logosToRender = LOGOS.slice(0, logosNumber);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSecurityLogos, {
                    className: "security-logos",
                    children: logosToRender.map(function(logo, index) {
                        return _this.renderLogo(logo, index);
                    })
                });
            }
        }
    ]);
    return SecurityLogos;
}(react.PureComponent);

SecurityLogos.defaultProps = default_props;


/***/ }),

/***/ 43640:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ AsymmetricEnterpriseComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./segments/desktop/core-components/security-logos/security-logos.js + 2 modules
var security_logos = __webpack_require__(90756);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/full-paragraph.js + 6 modules
var full_paragraph = __webpack_require__(13211);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/default-props.js
var default_props = __webpack_require__(7484);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/button-consts.js
var button_consts = __webpack_require__(75650);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/secondary-button/default-props.js
var secondary_button_default_props = __webpack_require__(28601);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/regular-button/default-props.js
var regular_button_default_props = __webpack_require__(57578);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/enterprise/layouts/asymmetric-enterprise/asymmetric-enterprise-component.scss.js



var MAX_ASYMETRIC_DIV_HEIGHT = 180;
var MACBOOK_ASYMETRIC_DIV_HEIGHT = 116;
var MOBILE_ASYMETRIC_DIV_HEIGHT = 90;
var SMALL_MOBILE_ASYMETRIC_DIV_HEIGHT = 80;
var widthBorder = function(colorName) {
    return "50vw solid ".concat(colors/* default */.Z[colorName]);
};
var heightBorder = function(colorName, divHeight) {
    return "".concat(divHeight / 2, "px solid ").concat(colors/* default */.Z[colorName]);
};
var StyledAsymmetricEnterpriseComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ebveo2u0"
})("background:", colors/* default.brand-enterprise-dark */.Z["brand-enterprise-dark"], ";display:flex;flex-direction:column;align-items:center;.asymetric-top-line-part{height:", MAX_ASYMETRIC_DIV_HEIGHT, "px;width:100%;border-right:", widthBorder("brand-enterprise-dark"), ";border-left:", function(param) {
    var topColor = param.topColor;
    return widthBorder(topColor);
}, ";border-bottom:", heightBorder("brand-enterprise-dark", MAX_ASYMETRIC_DIV_HEIGHT), ";border-top:", function(param) {
    var topColor = param.topColor;
    return heightBorder(topColor, MAX_ASYMETRIC_DIV_HEIGHT);
}, ";@media (max-width:", vp_sizes/* MACBOOK_PRO_MAX_WIDTH */.Wh, "){height:", MACBOOK_ASYMETRIC_DIV_HEIGHT, "px;border-bottom:", heightBorder("brand-enterprise-dark", MACBOOK_ASYMETRIC_DIV_HEIGHT), ";border-top:", function(param) {
    var topColor = param.topColor;
    return heightBorder(topColor, MACBOOK_ASYMETRIC_DIV_HEIGHT);
}, ";}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){height:", MOBILE_ASYMETRIC_DIV_HEIGHT, "px;border-bottom:", heightBorder("brand-enterprise-dark", MOBILE_ASYMETRIC_DIV_HEIGHT), ";border-top:", function(param) {
    var topColor = param.topColor;
    return heightBorder(topColor, MOBILE_ASYMETRIC_DIV_HEIGHT);
}, ";}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH_M */.TI, "){height:", SMALL_MOBILE_ASYMETRIC_DIV_HEIGHT, "px;border-bottom:", heightBorder("brand-enterprise-dark", SMALL_MOBILE_ASYMETRIC_DIV_HEIGHT), ";border-top:", function(param) {
    var topColor = param.topColor;
    return heightBorder(topColor, SMALL_MOBILE_ASYMETRIC_DIV_HEIGHT);
}, ";}}.enterprise-data{display:flex;flex-direction:column;align-items:center;margin-top:40px;.security-logos-wrapper{margin-top:32px;}.full-paragraph-component-wrapper{max-width:670px;margin:0 24px;}}.bottom-part{height:", MAX_ASYMETRIC_DIV_HEIGHT - 20, "px;@media (max-width:", vp_sizes/* MACBOOK_PRO_MAX_WIDTH */.Wh, "){height:", MACBOOK_ASYMETRIC_DIV_HEIGHT - 20, "px;}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){height:", MOBILE_ASYMETRIC_DIV_HEIGHT - 20, "px;}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH_M */.TI, "){height:", SMALL_MOBILE_ASYMETRIC_DIV_HEIGHT - 20, "px;}}");

;// CONCATENATED MODULE: ./segments/desktop/enterprise/layouts/asymmetric-enterprise/asymmetric-enterprise-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}









var AsymmetricEnterpriseComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(AsymmetricEnterpriseComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(AsymmetricEnterpriseComponent);
    function AsymmetricEnterpriseComponent() {
        (0,_class_call_check/* default */.Z)(this, AsymmetricEnterpriseComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(AsymmetricEnterpriseComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, fullParagraph = _props.fullParagraph, topColor = _props.topColor;
                var paragraphProps = _object_spread({}, fullParagraph);
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledAsymmetricEnterpriseComponent, {
                    topColor: topColor,
                    className: "asymmetric-enterprise-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "asymetric-top-line-part"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "enterprise-data",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "security-logos-wrapper",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(security_logos/* default */.Z, {
                                        smallLogos: true
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "full-paragraph-component-wrapper",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(full_paragraph/* default */.ZP, _object_spread({}, paragraphProps))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "bottom-part"
                        })
                    ]
                });
            }
        }
    ]);
    return AsymmetricEnterpriseComponent;
}(react.PureComponent);

AsymmetricEnterpriseComponent.defaultProps = {
    topColor: "white",
    fullParagraph: _object_spread_props(_object_spread({}, default_props/* default */.Z), {
        title: "monday.com for enterprise",
        body: "A fully scalable, flexible, and secure Work OS - powering your organization to outperform, faster",
        buttonConfig: _object_spread_props(_object_spread({}, default_props/* default.buttonConfig */.Z.buttonConfig), {
            secondaryButtonConfig: _object_spread_props(_object_spread({}, secondary_button_default_props/* default */.Z), {
                color: "white",
                isWithArrow: false
            }),
            regularButtonConfig: regular_button_default_props/* default */.Z,
            buttonType: button_consts/* TWO_LINK_BUTTONS_TYPE */.Q_
        }),
        textColor: "white",
        textAlign: "center",
        topic: {}
    })
};


/***/ })

}]);